
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-gap-assist-cmb.component.scss';

export class FormItemGapAssistCmb extends Base {

	gapAssistCmbForm: HTMLFormElement;
	gapAssistCmbSubmit: Element[];	
	formLoader: Element;
	formThankyou: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.gapAssistCmbForm = this.element.querySelector('form') as HTMLFormElement;
		this.gapAssistCmbSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
		this.formLoader = this.element.querySelector(".form__loader--container");
		this.formThankyou = this.element.querySelector(".form__thankyou--container");
	}

	bindEvents() {

		this.gapAssistCmbSubmit.map((item) => item.addEventListener('click', (event) => {
			const formFields: any = this.gapAssistCmbForm.querySelectorAll('input, select');
			
			this.validationService.validate(formFields);
			const valid = Array.from(this.gapAssistCmbForm.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.actionForm(this.gapAssistCmbForm);
			}
		}));
	}

	resetForm() {

		if (this.gapAssistCmbForm) {

			this.gapAssistCmbForm.reset();
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');

			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}

	}

	actionForm(form: HTMLFormElement) {

		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');
		
		// fields
		const source: any = form.querySelector('input[name=source]');
		const suppliercampaign: any = form.querySelector('input[name=supplier-campaign]');
		const title: any = form.querySelector('.js-title');
		const firstname: any = form.querySelector('input[name=first-name]');
		const lastname: any = form.querySelector('input[name=last-name]');
		const contact: any = form.querySelector('input[name=phone-number]');
		const email: any = form.querySelector('input[name=email-address]');

		// loader + hide form
		const fieldsContainer: any = form.querySelector('.form__fields--container');
		this.formLoader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/GapAssistService.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}
		let postData = '';

		// as per service
		if (source) {
			postData += 'source=' + source.value;
		}
		if (suppliercampaign) {
			postData += '&supplierCampaign=' + suppliercampaign.value;
		}
		if (title) {
			postData += '&title=' + title.value;
		}
		if (firstname) {
			postData += '&firstName=' + firstname.value;
		}
		if (lastname) {
			postData += '&lastName=' + lastname.value;
		}		
		if (contact) {
			postData += '&contactNum=' + contact.value;
		}
		if (email && email.value != "") {
			postData += '&emailAdd=' + email.value;
		}

		// service
		this.formsService.postForm(url, postData, config).then((response) => {
			this.formLoader.classList.remove('active');
			if (!response.data || (response.data == 'invalid')) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				error.classList.add('active');
				this.formThankyou.classList.add('active');
				success.classList.add('hidden');
			} else {
				analyticsService.dtmFormComplete('complete', response.code);
				this.formThankyou.classList.add('active');
				success.classList.add('active');
				error.classList.add('hidden');
			}
		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			this.formLoader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
}


// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-gap-assist-cmb/form-item-gap-assist-cmb.component.ts